module.exports = __webpack_public_path__ + "img/14.d15f7727.png";